import React, { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import MainPagetitle from "../../../layouts/MainPagetitle";
import FlexCard from "../LoanApplications/Helpers/FlexCard";
import { Flex, QRCode } from "antd";
import axios from "axios";
import OTPInput from "react-otp-input";
import { useModalForm } from "../../../../utils/hooks/useModalForm";

const MyApplicationView = (props) => {
  const BASE_URL = `${endpoints[environment].api_base}`;
  const fromPath = props?.urlparams?.params?.path;
  const toastConfig = {
    autoClose: 3000,
    closeButton: false,
    hideProgressBar: true,
  };
  const [show, setShow] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [amountToPay, setAmountToPay] = useState(0);
  const [applicationData, setApplicationData] = useState([]);
  const [editdata, setEditdata] = useState({});
  const [hasClosedLoan, setHasClosedLoan] = useState(false);

  const [checkValue, setCheckValue] = useState("currentOutstanding");
  const [collectionBankType, setCollectionBankType] = useState("idfc");

  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [transactionTableData, setTransactionTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [rowcount, setRowcount] = useState(0);

  const [amortCalcResponse, setAmortCalcResponse] = useState({});
  const amortizationColumns = [
    {
      dataIndex: "emiSequence",
      title: "Seq.",
    },
    {
      dataIndex: "emiRepaymentDate",
      title: "Payment Date",
      render: (text, record) => {
        if (record?.emiRepaymentDate) {
          let date = new Date(record?.emiRepaymentDate).dateToDDMMYYYY(
            new Date(record?.emiRepaymentDate)
          );
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "outstandingAmt",
      title: "Principal Outstanding",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "emiAmt",
      title: "EMI Amount",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "principalAmt",
      title: "Principal",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "interestAmt",
      title: "Interest",
      render: (text, record) => {
        return <span>{text?.cur() || "-"}</span>;
      },
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (text, record) => {
        let status = record?.status;
        let mappedStatus = _enum.STATUS_COLOR_MAP[status?.toLowerCase()] || "";

        return (
          <Dropdown className="status-dropdown pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              {status?.toTitleCase()}
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ];
  const transactionColumns = [
    {
      dataIndex: "loanAccountNumber",
      title: "LAN",
      render: (text, record) => {
        return <h6 className="text-primary">{text}</h6>;
      },
    },
    {
      dataIndex: "paymentDate",
      title: "Payment Date",
      render: (text, record) => {
        if (record?.paymentDate) {
          let date = new Date(record?.paymentDate).dateToDDMMYYYY(
            new Date(record?.paymentDate)
          );
          return date || "-";
        } else {
          return "-";
        }
      },
    },
    {
      dataIndex: "paymentAmt",
      title: "Payment Amount",
      // sorter: (a, b) => a.paymentAmt - b.paymentAmt,
      render: (text, record) => {
        return <>{text?.cur()}</>;
      },
    },
    {
      dataIndex: "paymentMode",
      title: "Payment Mode",
      render: (text, record) => {
        return <>{text?.toTitleCase()}</>;
      },
    },
    {
      dataIndex: "paymentStatus",
      title: "Payment Status",
      render: (text, record) => {
        let status = record?.paymentStatus || "pending";
        let mappedStatus = _enum.STATUS_COLOR_MAP[status?.toLowerCase()] || "";

        return (
          <Dropdown className="status-dropdown pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              {status?.toTitleCase()}
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
    {
      dataIndex: "paymentReferenceNum",
      title: "Payment Ref. No.",
    },
    {
      dataIndex: "totalAmt",
      title: "Total Amount",
      render: (text, record) => {
        return <>{text?.cur()}</>;
      },
    },
    // {
    //   dataIndex: "status",
    //   title: "Txn. Status",
    //   render: (text, record) => {
    //     let status = record?.status || "pending";
    //     let mappedStatus = _enum.STATUS_COLOR_MAP[status?.toLowerCase()] || "";

    //     return (
    //       <Dropdown className="status-dropdown pe-none">
    //         <Dropdown.Toggle as="div" className={mappedStatus}>
    //           {status?.toTitleCase()}
    //         </Dropdown.Toggle>
    //       </Dropdown>
    //     );
    //   },
    // },
  ];

  const onPageChange = (pageData) => {
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 10,
    });
  };

  const getApplication = () => {
    let payload = {
      applicationId: props.urlparams.params.id,
    };
    props.apis.apiGetCustomerApplicationById(payload).then((res) => {
      setEditdata(res);
      setApplicationData({
        loan_details: {
          loan_Id: res?.loanAccountNumber,
          loan_amount: res?.sanctionedLoanAmount?.cur(),
          start_date: res?.sanctionedLoanStartDate
            ? new Date(res?.sanctionedLoanStartDate).dateToDDMMYYYY(
              new Date(res?.sanctionedLoanStartDate)
            )
            : "-",
          end_date: res?.sanctionedLoanEndDate
            ? new Date(res?.sanctionedLoanEndDate).dateToDDMMYYYY(
              new Date(res?.sanctionedLoanEndDate)
            )
            : "-",
          loan_agreement: res?.loanAgreementFileId,
          tenure: res?.sanctionedLoanTenure,
          ROI: res?.sanctionedLoanIRR,
          processing_fee: res?.sanctionedLoanPF?.cur(),
          interest: res?.loanInterestAmtTillDate?.cur(),
          penal_interest: res?.penaltyInterestAmtTillDate?.cur(),
          total_payable: res?.totalAmountPayableAmtTillDate?.cur(),
          loan_status: res?.loanAccountStatus,
          outstanding_amount: res?.totalOutstandingAmtTillDate,
          settlement_letter: "-",
        },
      });

      if (res?.loanAccountNumber && res?.loanAccountStatus === "CLOSED") {
        // get NOC file
        downloadNoc(res?.loanAccountNumber);
      }
      // if (res?.loanAccountNumber) {
      //   // get SOA file
      //   props.apis
      //     .apiGetCustomerSoa({
      //       loanAccountNumber: res?.loanAccountNumber,
      //     })
      //     .then((res) => {
      //       console.log({ res });
      //       // Update the application data with SOA file ID
      //       setApplicationData((prevData) => ({
      //         ...prevData,
      //         loan_details: {
      //           ...prevData.loan_details,
      //           soa: res,
      //         },
      //       }));
      //     });
      // }

      setIsFetching(false);
      setHasClosedLoan(res?.loanAccountStatus === "CLOSED" ? true : false);

      if (res?.loanAccountNumber) {
        let repaymentPayload = {
          loanAccountNumber: res?.loanAccountNumber,
        };
        props.apis
          .apiGetCustomerAllLoanRepayments(repaymentPayload)
          .then(({data}) => {
            console.log({data});
            
            setTransactionTableData(data);
          });
      }
    });
  };

  const downloadNoc = async (loanAccountNumber) => {
    try {
      const url = `${BASE_URL}/api/v1/staff/loan-account/noc/download/${loanAccountNumber}`;
      const authToken = props?.$store?.auth;

      const response = await axios.get(url, {
        responseType: "arraybuffer",
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      const contentType =
        response.headers["content-type"]?.trim().toLowerCase() || "";

      // Case: Server returned a PDF
      if (contentType.includes("application/pdf")) {
        console.log({ response });

        setApplicationData((prevData) => ({
          ...prevData,
          loan_details: {
            ...prevData.loan_details,
            noc: response?.data,
          },
        }));
      } else {
        // Case: Server returned JSON error even with 200 status
        const text = new TextDecoder("utf-8").decode(
          new Uint8Array(response.data)
        );
        const json = JSON.parse(text);

        swal2.fire({
          title: json.message,
          icon: "error",
          iconColor: "#BB1766",
        });
      }
    } catch (err) {
      console.error("Failed to download NOC:", err);
      swal2.fire({
        title: "Something went wrong while fetching the NOC.",
        icon: "error",
        iconColor: "#BB1766",
      });
    }
  };

  const handleShow = (e) => {
    props.apis
      .apiAdminCalculateInterest({
        loanAccountNumber: editdata.loanAccountNumber,
      })
      .then((res) => {
        if (res) {
          console.log({ res });
          getApplication();
          setAmountToPay(res?.data?.summary?.totalOutstandingAmount);
        }
      });
    setShow(true);
  };

  const handleClose = (e) => {
    setShow(false);
    setQrCodeUrl(null);
    setAmountToPay(0);
    setCollectionBankType("idfc");
    setCheckValue("currentOutstanding")
  };

  const handlePayment = (e) => {
    e.persist();
    let value = e.target.value;
    if (e.target.name === "collectionBankType") {
      setCollectionBankType(value);
    } else {
      setCheckValue(value);
    }
  };

  const handleSubmit = (e, data) => {
    let payload = {
      loanAccountNumber: editdata.loanAccountNumber || '',
      // redirecturl: `${endpoints[environment].baseFE_URL}app/myapplications`,
    };

    if (checkValue === 'currentOutstanding') {
      payload.amount = Number(editdata?.totalOutstandingAmtTillDate) || '';
    } else {
      payload.amount = Number(data?.amount);
    }

    // console.log({ editdata, payload });

    const resolve = () => {
      handleClose();
      getApplication();
    };
    if (data?.collectionBankType === 'easebuzz') {
      props.apis
        .apiPayinEaseBuzzByCustomer(payload)
        .then((res) => {
          if (res) {
            let atag = document.createElement('a');
            const accessKey = res?.data?.accessKey;
            if (environment === 'production') {
              atag.href = `https://pay.easebuzz.in/pay/${accessKey}`;
            } else {
              atag.href = `https://testpay.easebuzz.in/pay/${accessKey}`;
            }
            atag.setAttribute('target', '_blank');
            document.body.appendChild(atag);
            atag.click();
            document.body.removeChild(atag);
            resolve();
          }
        })
        .catch((err) => {
          resolve();
        });
    }
    if (data?.collectionBankType === 'idfc') {
      let idfcPayload = {
        loanAccountNumber: payload?.loanAccountNumber,
        amount: JSON.stringify(payload?.amount),
      };
      console.log({ idfcPayload });
      setAmountToPay(payload?.amount);
      props.apis
        .apiPayinIdfcByCustomer(idfcPayload)
        .then(async (res) => {
          if (res) {
            console.log({ res });
            setQrCodeUrl(res?.data?.data?.intentUrl);
          }
        })
        .catch((err) => {
          resolve();
        });
    }
  };

  // ----------------------------------------------------------------
  const modalConfigs = {
    restructureLoan: [
      {
        name: "loanAccountNumber",
        label: "Loan Account Number",
        type: "text",
        readOnly: true,
        required: true,
      },
      {
        name: "totalAmountPayableAmtTillDate",
        label: "Outstanding",
        type: "text",
        readOnly: true,
        required: true,
      },
      {
        name: "overdue",
        label: "Overdue",
        type: "text",
        readOnly: true,
      },
      {
        name: "restructureWaiver",
        label: "Waiver",
        type: "number",
        step: ".01",
        readOnly: true,
        required: true,
      },
      {
        name: "sanctionedLoanAmt",
        label: "New Loan Amt",
        type: "number",
        readOnly: true,
        required: true,
      },
      {
        name: "restructureIRR",
        label: "ROI",
        type: "text",
        readOnly: true,
        required: true,
      },
      {
        name: "restructureTenure",
        label: "Tenure",
        type: "text",
        readOnly: true,
        required: true,
      },
      {
        name: "restructureLoanStartDate",
        label: "New Loan Start Date",
        type: "date",
        readOnly: true,
        required: true,
      },
      {
        name: "restructureLoanEndDate",
        label: "New Loan End Date",
        type: "date",
        readOnly: true,
        required: true,
      },
      {
        name: "remarks",
        label: "Admin Remarks",
        type: "text",
        readOnly: true,
        required: true,
      },
      {
        name: "customerRemarks",
        label: "Remarks",
        type: "textarea",
        required: true,
        colspan: "24",
      },
    ],
  };
  const dependencies = {};
  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, dependencies);

  // RESTRUCTURE LOAN
  const [loanRestructureData, setLoanRestructureData] = useState({});

  const openRestructureModal = () => {
    let defaultValues = {
      loanAccountNumber: editdata?.loanAccountNumber,
      totalAmountPayableAmtTillDate: editdata?.totalAmountPayableAmtTillDate,
      overdue: editdata?.overdue,
      restructureWaiver: editdata?.restructure?.restructureWaiver,
      sanctionedLoanAmt: editdata?.restructure?.sanctionedLoanAmt,
      restructureIRR: editdata?.restructure?.restructureIRR,
      restructureTenure: editdata?.restructure?.restructureTenure,
      restructureLoanStartDate: editdata?.restructure?.restructureLoanStartDate,
      restructureLoanEndDate: editdata?.restructure?.restructureLoanEndDate,
      remarks: editdata?.restructure?.remarks,
    };
    openModal("restructureLoan", "add", "Restructure Loan", defaultValues);
  };

  const handleAppModalSubmit = async (formData) => {
    if (modalState?.type === "restructureLoan") {
      if (modalState?.mode === "add") {
        let payload = {
          customerRemarks: formData?.customerRemarks,
        };

        console.log({ payload });

        // save form data
        setLoanRestructureData(payload);

        // trigger general otp
        props.apis
          .apiGeneralGenerateOtpVerify({
            loanAccountNumber: editdata?.loanAccountNumber,
          })
          .then((res) => {
            console.log({ res });
            openOTPModal();
          });
      }
    }
  };

  // ----------------------------------------------------------------
  const [showOTPModal, setShowOTPModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [isOtpDisabled, setIsOtpDisabled] = useState(true);

  const openOTPModal = () => {
    setShowOTPModal(true);
  };

  const closeOTPModal = () => {
    setShowOTPModal(false);
  };

  const handleOTPChange = (otp) => {
    // setOTP(otp);
    setOtpValue(otp);
    if (otp.length === 6) {
      setIsOtpDisabled(false);
    } else {
      setIsOtpDisabled(true);
    }
  };

  const handleOtpVerify = (e) => {
    let payload = {
      otpCode: otpValue,
      ...loanRestructureData,
    };
    console.log({ OTP: payload });

    // CALL CUSTOMER APPROVE RESTRUCTURE API
    props.apis
      .apiCustomerAcceptLoanRestructureRequest(payload, {
        loanAccountNumber: editdata?.loanAccountNumber,
      })
      .then((res) => {
        if (res) {
          console.log({ apiCustomerAcceptLoanRestructureRequest: res });
          swal2.fire({
            title: "Loan restructured accepted successfully.",
            icon: "success",
            iconColor: "#BB1766",
            showCancelButton: false,
            timer: 3000,
          });
          closeOTPModal();
          getApplication();
        }
      })
      .catch((err) => {
        console.log(err);
        setOtpValue("");
        closeOTPModal();
      });
  };

  const resendOTP = () => {
    // resend general otp
    props.apis
      .apiGeneralGenerateOtpVerify({
        loanAccountNumber: editdata?.loanAccountNumber,
      })
      .then((res) => {
        setOtpValue("");
        toast.success("OTP Re-Sent Successfully", toastConfig);
      });
  };
  // ----------------------------------------------------------------

  const getBackLink = () => {
    let url;
    if (fromPath === "customerhome") {
      url = "/app/customerhome";
    } else {
      url = "/app/myapplications";
    }
    return url;
  };

  useEffect(() => {
    getApplication();
  }, []);
  return (
    <>
      <MainPagetitle
        mainTitle={`My Application | (Application No.)${props.urlparams.params.id}`}
        back={"View"}
        backLink={getBackLink()}
        pageTitle={"My Application"}
        parentTitle={"Home"}
        pageIcon={imagepaths.greyUserCheckIconActive}
      />

      <div className="container-fluid">
        <div className="card p-4">
          <FlexCard
            title="Loan Details"
            data={applicationData && applicationData?.loan_details}
            colspan_key="col-3"
            colspan_value="col-3"
            hasPdfFile={true}
            pdfIdKey="loan_agreement"
          />

          {editdata?.loanPaymentMode === "EMI" && (
            <div className="mb-4">
              <Flex wrap gap="small" className="my-4">
                <div class="obligation_banner small">
                  <p class="">
                    Principal Amount Disbursed : Rs.{" "}
                    <span>{editdata?.sanctionedLoanAmount?.cur()}</span>
                  </p>
                </div>
                {/* <div class="obligation_banner small">
                  <p class="">
                    Total Interest : Rs.{" "}
                    <span>{editdata?.totalInterest?.cur()}</span>
                  </p>
                </div> */}
              </Flex>

              <AppTable
                data={
                  editdata?.emiSchedules?.sort(
                    (a, b) => a.emiSequence - b.emiSequence
                  ) || []
                }
                columns={amortizationColumns}
                total={editdata?.emiSchedules?.length || 0}
                reorder={true}
                viewable={false}
                deletable={false}
                editable={false}
              />
            </div>
          )}
          {!hasClosedLoan && (
            <div className="d-flex justify-content-end w-100">
              <button
                type="button"
                className="btn btn-primary"
                onClick={(...args) => handleShow(...args)}
              >
                Pay Now
              </button>

              {editdata?.loanAccountType === "RE_STRUCTURE" && (
                <button
                  type="submit"
                  className="btn btn-primary ms-2"
                  onClick={(...args) => openRestructureModal(...args)}
                  disabled={
                    editdata?.restructure?.restructureStatus === "ACCEPTED"
                      ? true
                      : false
                  }
                >
                  Restructure Loan
                </button>
              )}
            </div>
          )}
        </div>

        <div className="card p-4">
          <div className="form_group_card px-0">
            <div className="d-flex align-items-start justify-content-between">
              <h2 className="mb-3 theme_text_sm">Transaction History</h2>
            </div>
            <div>
              <AppTable
                data={transactionTableData}
                columns={transactionColumns}
                onChange={(...arg) => onPageChange(...arg)}
                total={rowcount}
                reorder={true}
                editable={false}
                viewable={false}
                deletable={false}
                loading={isFetching}
              ></AppTable>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={(...args) => handleClose(...args)}
        className="customer_application_modal payment_modal"
        backdrop="static" keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="justify-content-start w-100 mb-3">Payment</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-0">
          <AppForm onSubmit={handleSubmit}>
            <div className="payment_modal_content_box w-100">
              <p className="content_title text-start">How much you want to pay?</p>
              <div className="checkbox_container mb-4 flex-column">
                <div class="form-check me-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="currentOutstanding"
                    name="collectionType"
                    id="currentOutstanding"
                    onChange={(...args) => handlePayment(...args)}
                    checked={checkValue === "currentOutstanding"}
                  />
                  <label class="form-check-label" for="currentOutstanding">
                    Current Outstanding {amountToPay ? `of ${amountToPay?.cur()}` : null}
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="otherAmount"
                    name="collectionType"
                    id="otherAmount"
                    onChange={(...args) => handlePayment(...args)}
                    checked={checkValue === "otherAmount"}
                  />
                  <label class="form-check-label" for="otherAmount">
                    Other Amount
                  </label>
                </div>
                {checkValue === "otherAmount" && (
                <AppInput name="amount" label="Amount" type="number"></AppInput>
                )}
              </div>
              <p className=" text-start text-start">
                Payment Type
              </p>
              <div className="checkbox_container mb-4 flex">
                <div class="form-check me-3">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="idfc"
                    name="collectionBankType"
                    id="idfc"
                    onChange={(...args) => handlePayment(...args)}
                    checked={collectionBankType === 'idfc'}
                  />
                  <label class="form-check-label cursor-pointer" for="idfc">
                      <>
                        <img
                          src={imagepaths.UpiIcon}
                          className="img-fluid payment-img"
                          alt="upiIcon"
                        />
                        &nbsp; UPI
                      </>
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    value="easebuzz"
                    name="collectionBankType"
                    id="easebuzz"
                    onChange={(...args) => handlePayment(...args)}
                    checked={collectionBankType === 'easebuzz'}
                  />
                  <label class="form-check-label cursor-pointer" for="easebuzz">
                      <>
                        <img
                          src={imagepaths.blackCardIcon}
                          className="img-fluid payment-img"
                          alt="blackCardIcon"
                        />
                        &nbsp; Others
                      </>
                  </label>
                </div>
              </div>
            </div>
            <Modal.Footer className="justify-content-center">
              {!qrCodeUrl ? (
                <div className="w-100 d-flex justify-content-center mt-3">
                  <button
                    type="button"
                    className="btn btn-primary-lite me-3 px-4 py-2"
                    onClick={(...args) => handleClose(...args)}
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="btn btn-primary px-4 py-2"
                  >
                    Pay Now
                  </button>
                </div>
              ) : (
                <>
                <div className="qr-code-container w-100 d-flex flex-column align-items-center justify-content-center mt-3 p-4 rounded-3">
                  <h5 className="mb-4 fw-bold text-dark">
                    Scan Here To Pay ₹{Number(amountToPay).toLocaleString('en-IN')}
                  </h5>
                  <div className="qr-code-wrapper p-3 bg-white rounded-4 shadow-sm">
                    <QRCode value={qrCodeUrl} size={220} />
                  </div>
                </div>
                  <div className="w-100 d-flex justify-content-center mt-3">
                    <button
                      type="button"
                      className="btn btn-primary-lite me-3 px-4 py-2"
                      onClick={(...args) => handleClose(...args)}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              )}
            </Modal.Footer>
          </AppForm>
        </Modal.Body>
      </Modal>

      {/* RESTRUCTURE MODAL */}

      <AppFormModal
        form={appform}
        title={modalState.title}
        open={modalState.open}
        onClose={closeModal}
        fields={modalState.fields}
        onSubmit={handleAppModalSubmit}
        mode={modalState.mode}
      />

      {/* PAN MODAL */}
      <Modal
        show={showOTPModal}
        onHide={closeOTPModal}
        centered
        backdrop="static"
        className="consent_otp_modal"
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="pt-0">
          <div className="row g-3 mb-4">
            <div className="col-12 text-center">
              <h3 className="">Enter OTP</h3>
              <div className="d-flex justify-content-center">
                <OTPInput
                  value={otpValue}
                  onChange={(e) => handleOTPChange(e)}
                  separator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                  numInputs={6}
                  shouldAutoFocus={true}
                  isInputNum={true}
                  containerStyle="otp_container small p-0"
                />
              </div>
            </div>
            <div className="col-12 text-center">
              <div className="text-center otp_bottom">
                <span className="me-2">Not received OTP?</span>
                <button
                  className="btn px-0 text-primary fs-5 border-0"
                  disabled={isOtpDisabled}
                  onClick={(e) => resendOTP(e)}
                >
                  Resend
                </button>
              </div>
            </div>
            <div className="col-12 text-center">
              <button
                type="button"
                className="btn btn-primary-lite me-3"
                onClick={(e) => closeOTPModal()}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={(...args) => handleOtpVerify(...args)}
              >
                Submit
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default constore(MyApplicationView);
